import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { RemoteDiagnosticsStore, VddDetailsListStore } from '@store';

import { take } from 'rxjs/operators';
import { dataAtTheTimeOfFaultDetectionVddName } from '../../guided-troubleshooting.model';
import { PillType } from '../../../../../../shared/components/pill/pill.model';
@Component({
  selector: 'app-ecu',
  templateUrl: './ecu.component.html',
  styleUrls: ['./ecu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EcuComponent implements OnInit {
  readonly pillType = PillType;
  getAllActiveDtcLogicalLink$: Observable<string>;
  dataAtTheTimeOfFaultDetectionLoading$: Observable<boolean>;
  dataAtTheTimeOfFaultDetectionError$: Observable<boolean>;
  logicalLinkOfSelectedActiveError$: Observable<string>;

  @Input() gatewaySerial: string;

  constructor(
    private remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private vddDetailsListStore: VddDetailsListStore
  ) {}

  ngOnInit(): void {
    this.logicalLinkOfSelectedActiveError$ = this.remoteDiagnosticsStore.getLogicalLinkOfSelectedActiveError(
      this.gatewaySerial
    );

    this.logicalLinkOfSelectedActiveError$.pipe(take(1)).subscribe((logicalLink) => {
      this.dataAtTheTimeOfFaultDetectionLoading$ = this.vddDetailsListStore.isVddLoading(
        dataAtTheTimeOfFaultDetectionVddName,
        logicalLink
      );

      this.dataAtTheTimeOfFaultDetectionError$ = this.vddDetailsListStore.isVddReadInErrorState(
        dataAtTheTimeOfFaultDetectionVddName,
        logicalLink
      );
    });
  }
}
